import { j as r } from "../../jsx-runtime.BREq8dyb.js";
import { faXmark as _, faLock as R } from "@fortawesome/pro-light-svg-icons";
import { faExclamation as S } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as v } from "@fortawesome/react-fontawesome";
import { Tooltip as f, Autocomplete as $, Chip as z, ChipDelete as A, IconButton as F } from "@mui/joy";
import { d as L, e as q, g as K, m as M } from "../../lodash.DGoHQECz.js";
import { _ as T, a as W } from "../../_baseFlatten.BxmwniOT.js";
import { memo as B, useState as y, useMemo as m, useEffect as N } from "react";
import { z as E } from "../../zod.BRvRcVQy.js";
var X = T, Y = W, G = L, O = q, H = G(function(n, s) {
  return O(n) ? X(n, Y(s, 1, O, !0)) : [];
}), J = H;
const Q = /* @__PURE__ */ K(J), U = B(({
  error: n,
  valueLocks: s = [],
  onChange: g,
  value: l,
  slotProps: C,
  ...P
}) => {
  const [x, D] = y(""), [i, I] = y(), j = m(() => s.filter(({
    reason: e
  }) => e === "current").map(({
    value: e
  }) => e), [s]), h = m(() => s.filter(({
    reason: e
  }) => e === "default").map(({
    value: e
  }) => e), [s]), u = m(() => s.filter(({
    reason: e
  }) => e === "custom"), [s]), d = m(() => [...j, ...h, ...u.map(({
    value: e
  }) => e)], [j, u, h]);
  N(() => {
    const e = E.string().email("Email is invalid").optional().or(E.literal("")).safeParse(x);
    I(e.success ? void 0 : e.error);
  }, [x]);
  const k = m(() => (e) => /* @__PURE__ */ r.jsx(f, { title: i === void 0 ? "Clear all" : "Clear", children: /* @__PURE__ */ r.jsx("button", { ...e, onClick: i === void 0 ? e.onClick : () => D("") }) }), [i]), w = {
    clearIndicator: (e) => ({
      component: Q(e?.value, d).length ? k : () => null
    }),
    input: (e) => ({
      sx: {
        ...e.readOnly && {
          display: "none"
        }
      }
    }),
    root: (e) => ({
      sx: {
        ...e.readOnly && {
          cursor: "unset",
          paddingRight: 0
        }
      }
    })
  };
  return /* @__PURE__ */ r.jsx($, { endDecorator: i ? /* @__PURE__ */ r.jsx(f, { color: "danger", title: i?.issues?.[0]?.message, variant: "solid", children: /* @__PURE__ */ r.jsx(F, { color: "danger", component: "div", sx: {
    cursor: "unset",
    minWidth: "auto"
  }, children: /* @__PURE__ */ r.jsx(v, { icon: S }) }) }) : void 0, error: n && (Object.prototype.hasOwnProperty.call(n, "root") || Object.prototype.hasOwnProperty.call(n, "message")) || i !== void 0, freeSolo: !0, inputValue: x, multiple: !0, onChange: (e, a, o, t) => {
    if (!(o === "removeOption" && t?.option && d.includes(t?.option) && l?.indexOf(t?.option) === l?.lastIndexOf(t?.option)))
      return g?.(e, o === "clear" ? [...new Set(l?.filter((b) => d.includes(b)) || [])] : a, o, t);
  }, onInputChange: (e, a) => {
    D(a);
  }, onKeyDown: (e) => {
    e.key === "Enter" && i !== void 0 && (e.defaultMuiPrevented = !0);
  }, onPaste: (e) => {
    const a = e.clipboardData.getData("text").trim(), o = [`
`, ",", ";", " "];
    o.some((t) => a.includes(t)) && (e.preventDefault(), g?.(e, (l || []).concat(a.split(new RegExp(`[${o.join("")}]`)).map((t) => t.trim().toLowerCase().replace(/^["'](.+(?=["']$))["']$/, "$1"))), "createOption"));
  }, renderTags: (e, a) => e.map((o, t) => {
    const {
      key: b,
      ...V
    } = a({
      index: t
    }), c = e.findIndex((p) => p === o) !== t || !d.includes(o);
    return /* @__PURE__ */ r.jsx(f, { color: "danger", title: n?.[t]?.message, children: /* @__PURE__ */ r.jsx(z, { color: n?.[t] ? "danger" : "neutral", endDecorator: /* @__PURE__ */ r.jsx(f, { placement: n?.[t]?.message ? "right" : "top", title: c ? "" : u.some(({
      value: p
    }) => p === o) ? u.find(({
      value: p
    }) => p === o)?.message : j.includes(o) ? "You must be a participant" : h.includes(o) ? /* @__PURE__ */ r.jsxs("span", { children: [
      "Organization's contact emails must be notified",
      /* @__PURE__ */ r.jsx("br", {}),
      "and cannot be removed from the participants"
    ] }) : "Email is locked", children: /* @__PURE__ */ r.jsx(A, { ...c && V, sx: {
      cursor: c ? "pointer" : "unset"
    }, variant: "plain", children: /* @__PURE__ */ r.jsx(v, { icon: c ? _ : R }) }, b) }), size: "lg", slotProps: {
      endDecorator: {
        sx: {
          fontSize: "sm",
          pointerEvents: "all"
        }
      }
    }, sx: {
      cursor: "default",
      minWidth: 0
    }, variant: !c || n?.[t] ? "outlined" : "soft", children: o }) }, t);
  }), slotProps: M(w, C), value: l, ...P });
});
U.displayName = "DqParticipantsEditor";
export {
  U as default
};
//# sourceMappingURL=DqParticipantsEditor.js.map
